import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const mainContainerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(3),
  padding: theme.spacing(2),
  height: '100dvh',
});

export const cardStyle = css({
  width: '100%',
  backgroundColor: theme.colors.white,
  padding: theme.spacing(2),
  borderRadius: theme.borderRadius.medium,
  boxShadow: theme.shadows.floating,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
});

export const contentContainerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  flex: 1,
});

export const buttonContainerStyle = css({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row-reverse',
  gap: theme.spacing(2),
  width: '100%',

  [`@media (max-width: ${breakpoints.small.min}px)`]: {
    flexDirection: 'column',
  },
});
